export default "__VITE_ASSET__CeumPV$4__"